import React from 'react';
import {View} from 'react-native';
import {Header, SignUpSuspendedNotice} from '../../components/Elements';
import {useHeight} from '../Responsive';
import {Forms} from './components';

export const PreSignUpComponent: React.FC = React.memo(() => {
  const {windowHeight} = useHeight();
  return (
    <View style={{height: windowHeight}}>
      <SignUpSuspendedNotice />
      <Header />
      <Forms />
    </View>
  );
});

export {Forms};
